import { render, staticRenderFns } from "./catalog.component.vue?vue&type=template&id=1c6e6390&scoped=true&"
import script from "./catalog.component.vue?vue&type=script&lang=tsx&"
export * from "./catalog.component.vue?vue&type=script&lang=tsx&"
import style0 from "./catalog.component.vue?vue&type=style&index=0&id=1c6e6390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e6390",
  null
  
)

export default component.exports